import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import { useFormikContext, FieldArray } from "formik";
import LoadingOverlay from "components/shared/LoadingOverlay";
import LoadingButton from "components/shared/LoadingButton";
import CustomEditor from "components/TipTapEditor/CustomeEditor";

const AddSuggestionsModal = ({
  title,
  onCancel,
  confirmBtnText = "Save",
  show,
  setShow,
  therapists,
  noteTableId
}) => {

  const handleClose = () => {
    setShow(false);
  };

  const { values, isSubmitting, setFieldValue } = useFormikContext();

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal modal-v2`}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        {/* {(therapistsListLoading) && <LoadingOverlay />} */}
        <div className="text-center mx-auto">
          {/* Header */}
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderBottom: "1px solid #93278F" }}
          >
            <h3 className="mb-0 pb-0 section-title border-bottom-0" style={{ fontSize: "14px" }}>
              ADD SUGGESTIONS
            </h3>
            <img
              onClick={handleClose}
              width={16}
              height={16}
              src={crossIcon}
              alt="crossIcon"
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Table with Scrollbar */}
          <div
            // style={{
            //   maxHeight: "400px",
            //   overflowY: "auto",
            //   overflowX: "hidden",
            //   scrollbarWidth: "thin",
            //   scrollbarColor: "#b46c9f #f0f0f0",
            //   // border: "1px solid #ccc",
            //   // borderRadius: "8px",
            // }}
          >
            <Row>
              <Col md="12" className="mt-4 text-start">

                <FieldArray name="innerSuggestions">
                  {({ push, remove }) => (
                    <>
                      {values?.innerSuggestions?.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            // border: "1px solid #ccc",
                            // padding: "15px",
                            // borderRadius: "8px",
                            // marginBottom: "15px",
                          }}
                        >
                          <div className="d-flex justify-content-between py-2">
                            <label className="discharge-screen-label mt-0">
                              Suggestion {index + 1}
                            </label>
                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="d-flex align-items-center gap-2 justify-content-center discharge-screen btn-outline-danger"
                            >
                              Remove
                            </button>
                          </div>

                          <div className="editor-paren-v2 mt-2">
                            <CustomEditor
                              style={{ borderRadius: 0 }}
                              name={`innerSuggestions[${index}].text`}
                              attachmentName={`innerSuggestions[${index}].attachments`}
                            />
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary mt-2 blue-discharge-screen-btn"
                        onClick={() => push({ text: "" })}
                      >
                        + Add Suggestion
                      </button>
                    </>
                  )}
                </FieldArray>
              </Col>
            </Row>
          </div>


          {/* Buttons */}
          <div className="d-flex justify-content-end mt-4 gap-2">
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={isSubmitting}
              style={{
                backgroundColor: "#ccc",
                // color: "#000",
                border: "none",
                borderRadius: "0",
                padding: "6px 16px",
              }}
            >
              Cancel
            </Button>

            <LoadingButton
              type="button"
              onClick={() => {
                setFieldValue('suggestions', values?.innerSuggestions)
                handleClose()
              }}
              isLoading={isSubmitting}
              className="btn btn-primary"
              style={{
                backgroundColor: "#93278F",
                border: "none",
                borderRadius: "0",
                padding: "6px 16px",
              }}
            >
              {confirmBtnText}
            </LoadingButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddSuggestionsModal;
